<template>
  <div>
    <div
      class="molded-button"
      :class="{ fechado: !showFilter, aberto: showFilter }"
      v-show="!showFilter"
    >
      <i class="fas fa-arrow-circle-left"></i>
    </div>

    <transition name="slide-fade">
      <div
        class="molded-button button-recolher"
        v-show="showFilter"
        @click="showFilter = false"
      >
        <i class="fas fa-arrow-circle-right"></i>
      </div>
    </transition>

    <transition name="slide-fade"> </transition>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  components: {},
  data() {
    return {
      showFilter: false,
    };
  },
};
</script>

<style scoped>
.molded {
  background: white;
  border-left: solid 1px #dbdee0;
  font-size: 13px;
  height: 100%;
  width: 350px;
  right: 0px;
  padding: 10px;
  position: fixed;
  -webkit-box-shadow: 20px 20px 20px 20px rgba(124, 125, 129, 0.53);
  box-shadow: 20px 20px 20px 20px rgba(124, 125, 129, 0.53);
  z-index: 999;
}

.molded-button {
  font-size: 18px;
  background: #ffffff;
  border: solid 1px #dbdfe9;
  border-radius: 5px;
  color: #577696;
  height: 40px;
  width: 80px;
  line-height: 32px;
  padding-top: 3px;
  padding-right: 35px;
  text-align: center;
  position: fixed;
  top: 160px;
  cursor: pointer;
  z-index: 999;
}

.button-recolher {
  padding-left: 12px;
  padding-right: 418px;
  right: -38px;
}

.aberto {
  right: 365px;
}

.fechado {
  right: -38px;
  color: #577696;
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(200px);
  opacity: 0;
}
</style>
